export default "__VITE_ASSET__BxAxFajs__"